<template>
  <div id="app">
	<home></home>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import home from './components/home/home.vue'
// 瑞尔会展（山东）有限公司
// 
export default {
  name: 'app',
  components: {
    home
  }
}
</script>

<style>
	
@import url(style/animate.css);
@import url(style/style.css);
@import url(style/style_rpx.css);
body{
	margin:0px;
}
</style>
